var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.getGtmEventCheckoutItems.length
        ? _c("pc-gtm-event-logger", {
            key: 1,
            attrs: {
              eventName: _vm.GTMEventName,
              basketProducts: _vm.getGtmEventCheckoutItems || []
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getGtmEventCheckoutTrayItems.length
        ? _c("pc-gtm-event-logger", {
            key: 2,
            attrs: {
              eventName: _vm.GTMEventName,
              basketProducts: _vm.getGtmEventCheckoutTrayItems || []
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "checkout-confirmation-page-container" }, [
        _c(
          "section",
          { staticClass: "text-center bg-white main-heading-page" },
          [
            _c("h2", [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$resourceString["checkout.Title.OrderConfirmation"]
                  ) +
                  "                    \n            "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row align-items-start" }, [
            _c("div", { staticClass: "col-12 col-lg-8 col-xl-9" }, [
              _c("div", { staticClass: "checkout-confirmation-page-wrap" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "checkout-confirmation-page-details-row checkout-review-details-shipping "
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "primary-heading font-weight-bold checkout-confirmation-order-msg"
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Title.OrderConfirmation.Message"
                                  ]
                                ) +
                                "                                             \n                                    "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "checkout-confirmation-page-details-row checkout-review-details-shipping"
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "h5",
                          { staticClass: "primary-heading font-weight-bold" },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.ReviewBasket.Title.OrderSummary"
                                  ]
                                ) +
                                "                                            \n                                    "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-5 col-sm-6 col-12" }, [
                        _c(
                          "div",
                          { staticClass: "checkout-review-details-col" },
                          [
                            _c(
                              "div",
                              { staticClass: "details-label-heading" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$resourceString[
                                        "checkout.Shipping.Label.ShipTo"
                                      ]
                                    ) + ":"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "details-body" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "details-body-shipping-address"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentAddress.firstName) +
                                        " " +
                                        _vm._s(_vm.currentAddress.lastName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentAddress.suite
                                          ? _vm.currentAddress.addressLine1 +
                                              ", Suite " +
                                              _vm.currentAddress.suite
                                          : _vm.currentAddress.addressLine1
                                      ) + "."
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.currentAddress.city) +
                                        ", " +
                                        _vm._s(_vm.currentAddress.state) +
                                        ", " +
                                        _vm._s(_vm.currentAddress.postalCode) +
                                        ", " +
                                        _vm._s(_vm.currentAddress.country) +
                                        "."
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.shippingOption
                        ? _c(
                            "div",
                            { staticClass: "col-md-7 col-sm-6 col-12" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-review-details-col checkout-review-shipping-option-details"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "details-label-heading" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$resourceString[
                                              "checkout.Shipping.Label.ShippingOptions"
                                            ]
                                          ) + ":"
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "details-body" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-review-shipping-options-list"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getShippingOptionName(
                                                _vm.shippingOption
                                              ).title || "N/A"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getShippingOptionName(
                                                _vm.shippingOption
                                              ).description || "N/A"
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "checkout-confirmation-page-details-row checkout-review-details-shipping"
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "checkout-review-details-col" },
                          [
                            _c(
                              "div",
                              { staticClass: "details-label-heading" },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$resourceString[
                                        "checkout.ProjectInformation.Label.ProjectName"
                                      ]
                                    ) + ":"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "details-body" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "details-body-shipping-address"
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.projectInfo.projectName || "N/A"
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "checkout-confirmation-page-details-row checkout-review-details-shipping"
                  },
                  _vm._l(Object.keys(_vm.checkoutItemList), function(list) {
                    return _vm.checkoutItemList[list].length > 0
                      ? _c("div", { key: list }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "primary-heading font-weight-bold"
                                },
                                [
                                  list.toLowerCase() ===
                                  _vm.siteItems.toLowerCase()
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$resourceString[
                                              "myBasket.Label.IndividualSamples"
                                            ]
                                          ) +
                                            " : " +
                                            _vm._s(
                                              _vm.checkoutItemCount.siteItems
                                            )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  list.toLowerCase() ===
                                  _vm.projectItems.toLowerCase()
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$resourceString[
                                              "myBasket.Label.ProjectSamples"
                                            ]
                                          ) +
                                            " : " +
                                            _vm._s(
                                              _vm.checkoutItemCount.projectItems
                                            )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  list.toLowerCase() ===
                                  _vm.trayItems.toLowerCase()
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$resourceString[
                                              "myBasket.Label.DesignTraySample"
                                            ]
                                          ) +
                                            " : " +
                                            _vm._s(
                                              _vm.checkoutItemCount.trayItems
                                            )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "checkout-review-details-col" },
                                [
                                  _c("basket-item", {
                                    attrs: {
                                      listItems: _vm.checkoutItemList[list],
                                      listName:
                                        list.toLowerCase() ===
                                        _vm.siteItems.toLowerCase()
                                          ? _vm.siteItems
                                          : list.toLowerCase() ===
                                            _vm.projectItems.toLowerCase()
                                          ? _vm.projectItems
                                          : list.toLowerCase() ===
                                            _vm.trayItems.toLowerCase()
                                          ? _vm.trayItems
                                          : "",
                                      isCheckoutPage: true,
                                      isClearAll: false
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device"
              },
              [
                _c("div", { staticClass: "checkout-basket-sidebar-warpper" }, [
                  _c(
                    "div",
                    { staticClass: "checkout-basket-sidebar-container" },
                    [
                      _c("pc-basket-sidebar", {
                        attrs: {
                          confirmationPage: true,
                          nextLabel:
                            _vm.isTrayAvailable ||
                            _vm.isCartAvailable ||
                            _vm.isProjectAvailable
                              ? _vm.$resourceString[
                                  "myBasket.Button.GoToMyBasket"
                                ]
                              : "",
                          nextAction:
                            _vm.isTrayAvailable ||
                            _vm.isCartAvailable ||
                            _vm.isProjectAvailable
                              ? _vm.goToMyBasketHandler
                              : "",
                          exploreButtonOneLabel:
                            _vm.$resourceString[
                              "orderConfirmation.RightSideBar.FirstButton.Label"
                            ],
                          exploreButtonOneAction: _vm.exploreButtonOneAction,
                          exploreButtonTwoLabel:
                            _vm.$resourceString[
                              "orderConfirmation.RightSideBar.SecondButton.Label"
                            ],
                          exploreButtonTwoAction: _vm.exploreButtonTwoAction
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }